/**
 * PR レビュー環境専用: ログイン画面の入力欄をクエリ文字列から初期設定する。
 *
 * - `/login?email=...&password=...` の値をメールアドレス / パスワード欄の初期値にする。
 * - **ビルド時の環境変数 `VITE_ENABLE_LOGIN_PREFILL=true` のときだけ有効**。
 *   これを渡すのは `pr-stg-deploy.yml` の web-app ビルドだけで、
 *   `deploy-stg.yml` / `deploy-prod.yml` では渡さない。
 *   そのため stg / 本番のビルドでは常に無効 (クエリを読まず、入力欄は空のまま)。
 */

export interface LoginPrefill {
  email: string;
  password: string;
}

/** PR レビュー環境向けビルドでのみ true になる。 */
export function isLoginPrefillEnabled(): boolean {
  return import.meta.env.VITE_ENABLE_LOGIN_PREFILL === 'true';
}

/** `location.search` から email / password を取り出す。無効なビルドでは常に空文字を返す。 */
export function readLoginPrefill(search: string): LoginPrefill {
  if (!isLoginPrefillEnabled()) {
    return { email: '', password: '' };
  }
  const params = new URLSearchParams(search);
  return {
    email: params.get('email') ?? '',
    password: params.get('password') ?? '',
  };
}
